import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { TextField } from '@/components/functional/Form/TextField';
import { FieldLabel } from '@/components/ui/Form/FieldLabel';
import { FIELD_DOM_CLASS_NAME } from '@/utils/form/scroll';
import { validateEmail } from '@/utils/validate/common';
/**
 * お問い合わせ メールアドレス入力フィールド
 * @param props
 * @returns
 */
export const ContactMainEmailField = (props) => {
    const { className = '', name } = props;
    return (_jsx(FieldLabel, Object.assign({ className: clsx(FIELD_DOM_CLASS_NAME, className), labelText: 'メールアドレス' }, { children: _jsx(TextField, { name: name, placeholder: 'mailaddress@mailaddress.com', type: 'email', validate: validateEmail }) })));
};
